var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import cookies from 'js-cookie';
import { pathToRegexp } from 'path-to-regexp';
import { compact, isString } from '@ally/utilitarian';
var clampToRoot = function (x) { return "/" + x.replace(/^\.?\/+/, ''); };
function toRouteRegExp(_a, pattern) {
    var log = _a.log;
    try {
        return pathToRegexp(pattern);
    }
    catch (e) {
        log.error({ message: "Ignoring invalid path expression: " + pattern });
        return null;
    }
}
export function isLocalhost(hostname) {
    if (hostname === void 0) { hostname = window.location.hostname; }
    return ['localhost', '127.0.0.1', '0.0.0.0'].includes(hostname);
}
export function getWarpDestination(path) {
    return new URL(path, window.location.origin).toString();
}
export function findsMatchingRoute(config) {
    return function (routes, path) {
        var pathname = new URL(path, window.location.origin).pathname;
        return routes.find(function (_a) {
            var _b;
            var match = _a.match;
            return ((_b = toRouteRegExp(config, match)) === null || _b === void 0 ? void 0 : _b.test(pathname)) || false;
        });
    };
}
export function isWGActive(_a) {
    var _b = _a.activeCookie, activeCookie = _b === void 0 ? 'wa' : _b, _c = _a.isActive, isActive = _c === void 0 ? false : _c;
    return isActive || cookies.get(activeCookie) === 'true';
}
/**
 * Given a set of "raw routes", will convert them into fully resolved "Route"
 * objects who's `match` property is a `pathToRegexp` converted regular
 * expression.
 *
 * Handles bad/malformed input by ignoring it altogether. This can occur when:
 * a route is falsy or an empty string, or an object route has a falsy `match`
 * property.
 */
export function getSanitizedRoutes(config) {
    var log = config.log, getRoutes = config.getRoutes, _a = config.fallbackTarget, fallbackTarget = _a === void 0 ? 'react' : _a;
    var routes = getRoutes();
    if (!Array.isArray(routes) || !isWGActive(config))
        return null;
    return compact(routes.map(function (route) {
        var _a = isString(route)
            ? { match: route }
            : __assign({}, (typeof route === 'object' ? route : {})), _b = _a.match, match = _b === void 0 ? null : _b, _c = _a.target, target = _c === void 0 ? fallbackTarget : _c;
        if (!match) {
            log.warn({ message: "[WG] Malformed route: " + route });
            return null;
        }
        return {
            match: clampToRoot(match),
            target: target,
        };
    }));
}
export function getSanitizedPath(path) {
    try {
        var _a = new URL(path), hash = _a.hash, origin_1 = _a.origin, pathname = _a.pathname;
        return pathname === '/' && hash ? "" + origin_1 + hash.slice(1) : path;
    }
    catch (error) {
        return path;
    }
}
//# sourceMappingURL=utils.js.map